module.exports = __webpack_public_path__ + "img/2.d28aa7a0.svg";